import React, { useEffect } from 'react';
import { Modal, Button, ModalHeader, ModalBody } from 'reactstrap';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber,settings } from "firebase/auth";
import { auth } from 'firebaseconfig';

const OTPVerificationModal = ({ isOpen, toggle, phoneNumber }) => {

    useEffect(() => {
        if (isOpen && phoneNumber) {
            // const auth = getAuth();
            window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-modal', {
                'size': 'invisible'
            }, auth);
            window.recaptchaVerifier.render();
        }
    }, [isOpen, phoneNumber]);

    const sendOtp = () => {
        const appVerifier = window.recaptchaVerifier;
        signInWithPhoneNumber(auth, phoneNumber, appVerifier)
            .then((confirmationResult) => {
                console.log("OTP sent", confirmationResult);
                toggle(); // Close modal on successful OTP send
            })
            .catch((error) => {
                console.error('Error sending OTP:', error);
                toggle(); // Optionally close modal on error or handle differently
            });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Verify Phone Number</ModalHeader>
            <ModalBody>
                <div>Please confirm the CAPTCHA to proceed</div>
                <div id="recaptcha-modal"></div>
                <Button color="primary" onClick={sendOtp} style={{ marginTop: '20px' }}>
                    Send OTP
                </Button>
            </ModalBody>
        </Modal>
    );
};

export default OTPVerificationModal;
